import { CustomError } from '@release/shared/lib/error';
import { logError } from '@release/shared/lib/logger';
import { FirebaseApp, getApps, initializeApp } from 'firebase/app';
import { getMessaging, getToken, isSupported, Messaging } from 'firebase/messaging';

import {
  FIREBASE_API_KEY,
  FIREBASE_APP_ID,
  FIREBASE_MESSAGING_SENDER_ID,
  FIREBASE_MESSAGING_VAPID_KEY,
  FIREBASE_PROJECT_ID,
} from '@/env';

export const firebaseConfig = {
  apiKey: FIREBASE_API_KEY,
  projectId: FIREBASE_PROJECT_ID,
  appId: FIREBASE_APP_ID,
  messagingSenderId: FIREBASE_MESSAGING_SENDER_ID,
};

let firebaseApp: FirebaseApp | null = null;
let firebaseMessaging: Messaging | null = null;
const getFirebaseApp = () => {
  if (firebaseApp) {
    return firebaseApp;
  }
  return (firebaseApp = initializeApp(firebaseConfig));
};
const getFirebaseMessaging = async () => {
  firebaseApp = getFirebaseApp();
  if (firebaseMessaging) {
    return firebaseMessaging;
  }
  const supported = await isSupported();
  if (supported && firebaseApp) {
    return (firebaseMessaging = getMessaging(firebaseApp));
  }
  return null;
};
if (typeof navigator !== 'undefined' && !getApps().length) {
  firebaseApp = getFirebaseApp();
  getFirebaseMessaging()
    .then((messaging) => {
      firebaseMessaging = messaging;
    })
    .catch((e) => {
      logError(e);
    });
}

export const requestFCMToken = async () => {
  let perm = Notification.permission;
  if (perm === 'default') {
    perm = await Notification.requestPermission();
    // if (perm === 'granted' && navigator.serviceWorker.controller) {
    //   navigator.serviceWorker.controller.postMessage({
    //     type: 'GRANT_NOTIFICATION_PERMISSION',
    //   });
    // }
  }
  if (perm !== 'granted') {
    throw new CustomError(null, {
      customMessage: 'プッシュ通知の許可が必要です',
    });
  }
  const messaging = await getFirebaseMessaging();
  if (!messaging) {
    throw new Error('firebaseMessaging is not initialized');
  }
  const sw = await navigator.serviceWorker.ready;
  return getToken(messaging, {
    vapidKey: FIREBASE_MESSAGING_VAPID_KEY,
    serviceWorkerRegistration: sw,
  });
};

export { getFirebaseApp, getFirebaseMessaging };
